import { Search } from '@shinetools/lumen-react'
import { forwardRef, KeyboardEvent, ReactElement, Ref, useCallback } from 'react'

import { useBalanceLabels } from '@features/balanceLedger'

import { useDebouncedSearchInput } from '../../../../../../../../hooks/useDebouncedSearchInput'
import { useSupplierListFilters } from '../../../../../../hooks/useSupplierListFilters'
import * as Styled from './styles'

interface Props {
  /** ArrowDown handler that moves focus into the result list. */
  onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void
}

export const SupplierListSearch = forwardRef(({ onKeyDown }: Props, ref: Ref<HTMLInputElement>): ReactElement => {
  const { bt } = useBalanceLabels()
  const [{ searchQuery }, setFilters] = useSupplierListFilters()

  const handleSearchUpdate = useCallback(
    (value: string) => {
      setFilters({ searchQuery: value || undefined })
    },
    [setFilters],
  )

  const { onChange: handleChange, value } = useDebouncedSearchInput(searchQuery, handleSearchUpdate)

  return (
    <Styled.SearchWrapper>
      <Search
        rounded
        noDropdown
        onChange={handleChange}
        onKeyDown={onKeyDown}
        placeholder={bt('toolbar.search.placeholder')}
        ref={ref}
        size="small"
        value={value}
      />
    </Styled.SearchWrapper>
  )
})

SupplierListSearch.displayName = 'SupplierListSearch'
